export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0 || isNaN(bytes)) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const validateFileName = (fileName: string): void => {
  const regex = /["*/?<>:|]/;
  if (regex.test(fileName)) {
    throw new Error(`File names cannot contain special characters ("*/?<>:|).`);
  }
};

export const validateFileSize = (fileSize: number, maxSize: number): void => {
  if (fileSize > maxSize * 1024 * 1024) {
    throw new Error(`File size exceeds the maximum (${maxSize}MB).`);
  }
};

export const formatDate = (date: string, isUTC = false): string =>
  date &&
  new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    ...(isUTC && { timeZone: "UTC" }),
  });
